import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const Sidebar = ({ sidebarSections }) => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;
  return (
    <div>
      {sidebarSections.map((section, i) => (
        <NavLink to={section.path} key={i}>
          <div
            key={section}
            className={`md:p-4 py-3 px-2 cursor-pointer md:text-[1rem] text-[.8rem] font-inter-600 flex items-center hover:bg-[#E6E6E6]   ${
              isActive(section.path)
                ? "bg-[#E6E6E6] text-[#0D868C] "
                : "bg-white text-[#A9A9A9] "
            }`}
          >
            {section.icon && (
              <span className="md:mr-2 mr-1">{section.icon}</span>
            )}
            {isActive(section.path)
              ? section.image2 && (
                  <img
                    src={section.image2}
                    className="w-4 md:mr-2 mr-1"
                    alt=""
                  />
                )
              : section.image1 && (
                  <img
                    src={section.image1}
                    className="w-4 md:mr-2 mr-1"
                    alt=""
                  />
                )}
            <span>{section.name}</span>
          </div>
        </NavLink>
      ))}
    </div>
  );
};

export default Sidebar;
